import { render, staticRenderFns } from "./fileuploader.vue?vue&type=template&id=99c6b7a8"
import script from "./fileuploader.vue?vue&type=script&lang=ts"
export * from "./fileuploader.vue?vue&type=script&lang=ts"
import style0 from "./fileuploader.vue?vue&type=style&index=0&id=99c6b7a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports